(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    

const popup = document.querySelector('#shopify-section-popup');
const popupClose = document.querySelector('.popup__close');
const popupLink = document.querySelector('.popup__content a');
const body = document.querySelector('body');
//const startDate = new Date(2022,4,8,0,0,0);
const startDate = new Date(2022,4,3,12,0,0);
//const endDate = new Date(2022,4,15,11,59,0);
const endDate = new Date(2022,4,29,12,3,0);
const today = new Date();
let popupIsActive = false;

console.log("popup");

if(popup) {

    // Check date range
    checkDate();

	// display popup if active and cookie not present
	checkCookie();

    // Close video lightbox
    popup.addEventListener('click', function(e) {
        //e.preventDefault();
        //closePopup();
    });

    // On close button close lightbox
    popupClose.addEventListener('click', function(e) {
        e.preventDefault();
        closePopup();
    });

    // Close search field if user clicks out of search box
    document.addEventListener('mouseup', function (event) {
        if(event.target == popupLink) {
			document.cookie = "popupStatus=Closed";
			//console.log("set cookie");
        } else {
            closePopup();
        }
    });
}
  
// get Cookie and check
function checkCookie() {
  let popupCookie = getCookie("popupStatus");
  if (popupCookie == "Closed") {
	console.log("cookie is set so don't open popup");
  } else {
	console.log("no cookie set");
	activatePopup();
  }

// Get Cookie by name
function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res
}


}

// Try and open popup
function activatePopup() {
	if ( popupIsActive == true ) {
		console.log("opening popup");
		openPopup();
	} else {
		console.log("not able to open popup due to outside date range");
	}
}

// Check date range
function checkDate() {
	if ( today >= startDate && today <= endDate ) {
		popupIsActive = true;
	}
}

// Close popup
function closePopup() {
    popup.style.display = "none";
    body.classList.remove("no-scroll");
	document.cookie = "popupStatus=Closed;max-age=86400;path=/"
	console.log('close popup - cookie "popupStatus=Closed"should be set now');
}

// Open popup
function openPopup() {
  body.classList.add('no-scroll');
  popup.style.display = 'flex';
}

    // Keyboard controls
	document.addEventListener('keydown', function(e) {
        switch(e.which) {
            case 13: // enter
                if(popup.classList.contains('display') != 'none') {
					//closePopup();
                }
            case 27: // escape
                if(popup.classList.contains('display') != 'none') {
                    closePopup();
                }
            break;

            default: return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
